/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

/**
 * Reasons for denying an RxChange request.
 */
export type RxChangeDenialReasonT =
  (typeof RxChangeDenialReasonT)[keyof typeof RxChangeDenialReasonT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RxChangeDenialReasonT = {
  DeniedPatientUnknown: "DeniedPatientUnknown",
  DeniedPatientNotUnderCare: "DeniedPatientNotUnderCare",
  DeniedPatientNoLongerUnderPatientCare:
    "DeniedPatientNoLongerUnderPatientCare",
  DeniedNeverPrescribed: "DeniedNeverPrescribed",
  DeniedHavePatientContact: "DeniedHavePatientContact",
  DeniedChangeInappropriate: "DeniedChangeInappropriate",
  DeniedNeedAppointment: "DeniedNeedAppointment",
  DeniedPrescriberNotAssociateWithLocation:
    "DeniedPrescriberNotAssociateWithLocation",
  DeniedNoPriorAuthAttempt: "DeniedNoPriorAuthAttempt",
  DeniedAlreadyHandled: "DeniedAlreadyHandled",
  DeniedAtPatientRequest: "DeniedAtPatientRequest",
  DeniedPriorAuthNoAttempt: "DeniedPriorAuthNoAttempt",
  DeniedPriorAuthInProgress: "DeniedPriorAuthInProgress",
  DeniedOrderNotFound: "DeniedOrderNotFound",
  DeniedPayerNoPriorAuth: "DeniedPayerNoPriorAuth",
  DeniedPatientNoRecord: "DeniedPatientNoRecord",
  DeniedOrderExpired: "DeniedOrderExpired",
  DeniedPharmacyNotRecognized: "DeniedPharmacyNotRecognized",
} as const;
